import React, { useCallback } from "react"
import { useSelector, useDispatch } from "react-redux"
import { PLOTTYPE } from "../logic/chartConfig"
import { changePlotType } from "redux/ducks/Chart"
import ChartBaseSelector from "./ChartBaseSelector"
import { dropRight } from "lodash"

interface props {
  canvasId: string
  isMiddle?: boolean
}

const ChartPlotFilter = React.memo((props: props) => {
  const { canvasId } = props
  const dispatch = useDispatch()
  const plotTypeSelector = (state: any) => state.chart[canvasId].plotType
  const relativeChartFlagSelector = (state: any) =>
    state.chart[canvasId].relativeChartFlag
  const plotType = useSelector(plotTypeSelector)
  const relativeChartFlag = useSelector(relativeChartFlagSelector)
  const setPlotType = useCallback((id: number) => {
    dispatch(changePlotType(canvasId, id))
  }, [])

  return (
    <div className="chart-plot-filter">
      <ChartBaseSelector
        list={!props.isMiddle ? PLOTTYPE : dropRight(PLOTTYPE)}
        onChange={setPlotType}
        defaltValueId={plotType.id}
        disabled={(id: number) => {
          return relativeChartFlag && PLOTTYPE[3].id === id
        }}
      />
    </div>
  )
})

export default ChartPlotFilter
